import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
	inviteUser: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/invite',
					method: 'POST',
					body: request,
					types: [types.INVITE_USER_REQUEST, types.INVITE_USER_SUCCESS, types.INVITE_USER_FAILURE],
				},
			});
		};
	},
	reinviteUser: (userId, msg) => {
		return (dispatch) => {
			const body = {
				userId: userId,
				inviteMessage: msg,
			};
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/reinvite',
					method: 'POST',
					body: body,
					types: [types.INVITE_USER_REQUEST, types.INVITE_USER_SUCCESS, types.INVITE_USER_FAILURE],
				},
			});
		};
	},
	loadUser: (subscriptionId, userId) => {
		return (dispatch) => {
			const body = {
				subscriptionId: subscriptionId,
				userId: userId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user',
					method: 'POST',
					body: body,
					types: [types.LOAD_USER_REQUEST, types.LOAD_USER_SUCCESS, types.LOAD_USER_FAILURE],
				},
			});
		};
	},
	loadInviteUserFilters: (subscriptionId) => {
		return (dispatch) => {
			const body = {
				subscriptionId: subscriptionId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user/invite-filters',
					method: 'POST',
					body: body,
					types: [types.LOAD_INVITE_USER_FILTERS_REQUEST, types.LOAD_INVITE_USER_FILTERS_SUCCESS, types.LOAD_INVITE_USER_FILTERS_FAILURE],
				},
			});
		};
	},
	loadLocationsFilters: (userId, subscriptionId) => {
		return (dispatch) => {
			const body = {
				userId: userId,
				subscriptionId: subscriptionId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user/locations-filters',
					method: 'POST',
					body: body,
					types: [types.LOAD_LOCATIONS_FILTERS_REQUEST, types.LOAD_LOCATIONS_FILTERS_SUCCESS, types.LOAD_LOCATIONS_FILTERS_FAILURE],
				},
			});
		};
	},
	searchUsers: (filterRequest) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/search',
					method: 'POST',
					body: filterRequest,
					types: [types.SEARCH_USER_REQUEST, types.SEARCH_USER_SUCCESS, types.SEARCH_USER_FAILURE],
				},
			});
		};
	},
	searchGlocalUsers: (filterRequest) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/global-search',
					method: 'POST',
					body: filterRequest,
					types: [types.SEARCH_USER_REQUEST, types.SEARCH_USER_SUCCESS, types.SEARCH_USER_FAILURE],
				},
			});
		};
	},
	updateUser: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/update',
					method: 'POST',
					body: request,
					types: [types.UPDATE_USER_REQUEST, types.UPDATE_USER_SUCCESS, types.UPDATE_USER_FAILURE],
				},
			});
		};
	},
	loadUserBulkLocationSearchFilters: (subscriptionId) => {
		return (dispatch) => {
			const body = {
				subscriptionId: subscriptionId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user/bulk-location-filters',
					method: 'POST',
					body: body,
					types: [
						types.LOAD_USER_BULK_LOCATION_FILTERS_REQUEST,
						types.LOAD_USER_BULK_LOCATION_FILTERS_SUCCESS,
						types.LOAD_USER_BULK_LOCATION_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	searchUserLocations: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/search-locations',
					method: 'POST',
					body: request,
					types: [
						types.SEARCH_USER_LOCATION_FILTERS_REQUEST,
						types.SEARCH_USER_LOCATION_FILTERS_SUCCESS,
						types.SEARCH_USER_LOCATION_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	updateLocations: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/locations',
					method: 'POST',
					body: request,
					types: [types.UPDATE_USER_LOCATIONS_REQUEST, types.UPDATE_USER_LOCATIONS_SUCCESS, types.UPDATE_USER_LOCATIONS_FAILURE],
				},
			});
		};
	},
	setDefaultLocation: (locationId) => {
		return (dispatch) => {
			const body = {
				defaultLocationId: locationId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user/set-default-location',
					method: 'POST',
					body: body,
					types: [types.SET_DEFAULT_LOCATION_REQUEST, types.SET_DEFAULT_LOCATION_SUCCESS, types.SET_DEFAULT_LOCATION_FAILURE],
				},
			});
		};
	},
	acknowledgeWelcomeMessage: (revisionId) => {
		return (dispatch) => {
			const body = {
				welcomeMessageRevisionId: revisionId,
			};

			return dispatch({
				[CALL_API]: {
					endpoint: 'user/acknowledge-welcome-message',
					method: 'POST',
					body: body,
					types: [
						types.ACKNOWLEDGE_WELCOME_MESSAGE_REQUEST,
						types.ACKNOWLEDGE_WELCOME_MESSAGE_SUCCESS,
						types.ACKNOWLEDGE_WELCOME_MESSAGE_FAILURE,
					],
				},
			});
		};
	},
	myProfile: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/my-profile',
					method: 'GET',
					types: [types.LOAD_MY_PROFILE_REQUEST, types.LOAD_MY_PROFILE_SUCCESS, types.LOAD_MY_PROFILE_FAILURE],
				},
			});
		};
	},
	loadMyProfileFilters: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/my-profile-filters',
					method: 'GET',
					types: [types.LOAD_MY_PROFILE_FILTERS_REQUEST, types.LOAD_MY_PROFILE_FILTERS_SUCCESS, types.LOAD_MY_PROFILE_FILTERS_FAILURE],
				},
			});
		};
	},
	saveAccountDetails: (user) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/save-account-details',
					method: 'POST',
					body: user,
					types: [types.SAVE_ACCOUNT_DETAILS_REQUEST, types.SAVE_ACCOUNT_DETAILS_SUCCESS, types.SAVE_ACCOUNT_DETAILS_FAILURE],
				},
			});
		};
	},
	saveConfiguration: (user) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/save-configuration',
					method: 'POST',
					body: user,
					types: [
						types.SAVE_MY_PROFILE_CONFIGURATION_REQUEST,
						types.SAVE_MY_PROFILE_CONFIGURATION_SUCCESS,
						types.SAVE_MY_PROFILE_CONFIGURATION_FAILURE,
					],
				},
			});
		};
	},
	loadSupportFilters: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/support-filters',
					method: 'GET',
					types: [
						types.LOAD_USER_SUPPORT_FILTERS_REQUEST,
						types.LOAD_USER_SUPPORT_FILTERS_SUCCESS,
						types.LOAD_USER_SUPPORT_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	loadNotificationFilters: (subscriptionId, userId) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/notification-filters',
					method: 'POST',
					body: { subscriptionId, userId },
					types: [
						types.LOAD_NOTIFICATION_FILTERS_REQUEST,
						types.LOAD_NOTIFICATION_FILTERS_SUCCESS,
						types.LOAD_NOTIFICATION_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	loadNotificationSettings: (subscriptionId, userId) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/notification-settings',
					method: 'POST',
					body: { subscriptionId, userId },
					types: [
						types.LOAD_NOTIFICATION_SETTINGS_REQUEST,
						types.LOAD_NOTIFICATION_SETTINGS_SUCCESS,
						types.LOAD_NOTIFICATION_SETTINGS_FAILURE,
					],
				},
			});
		};
	},
	saveNotificationSettings: (settings) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/save-notification-settings',
					method: 'POST',
					body: settings,
					types: [
						types.SAVE_NOTIFICATION_SETTINGS_REQUEST,
						types.SAVE_NOTIFICATION_SETTINGS_SUCCESS,
						types.SAVE_NOTIFICATION_SETTINGS_FAILURE,
					],
				},
			});
		};
	},
	grantAccessToAllBaselines: (userId) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/grant-all-baselines',
					method: 'POST',
					body: { userId: userId },
					types: [types.GRANT_USER_ALL_BASELINES_REQUEST, types.GRANT_USER_ALL_BASELINES_SUCCESS, types.GRANT_USER_ALL_BASELINES_FAILURE],
				},
			});
		};
	},
	updateFollowedDepartments: (departmentIds) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/update-followed-departments',
					method: 'POST',
					body: { departmentIds: departmentIds },
					types: [
						types.SAVE_FOLLOWED_DEPARTMENTS_REQUEST,
						types.SAVE_FOLLOWED_DEPARTMENTS_SUCCESS,
						types.SAVE_FOLLOWED_DEPARTMENTS_FAILURE,
					],
				},
			});
		};
	},
	updateIsActive: (userId, isActive) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/update-isActive',
					method: 'POST',
					body: {
						id: userId,
						isActive: isActive,
					},
					types: [types.UPDATE_USER_ISACTIVE_REQUEST, types.UPDATE_USER_ISACTIVE_SUCCESS, types.UPDATE_USER_ISACTIVE_FAILURE],
				},
			});
		};
	},
	getMissingProfileInputFilters: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/missing-profile-filters',
					method: 'GET',
					types: [
						types.GET_MISSING_PROFILE_INPUT_FILTERS_REQUEST,
						types.GET_MISSING_PROFILE_INPUT_FILTERS_SUCCESS,
						types.GET_MISSING_PROFILE_INPUT_FILTERS_FAILURE,
					],
				},
			});
		};
	},
	saveMissingProfileInput: (profileInfo) => {
		return (dispath) => {
			return dispath({
				[CALL_API]: {
					endpoint: 'user/missing-profile-save',
					method: 'POST',
					body: profileInfo,
					types: [
						types.SAVE_MISSING_PROFILE_INPUT_REQUEST,
						types.SAVE_MISSING_PROFILE_INPUT_SUCCESS,
						types.SAVE_MISSING_PROFILE_INPUT_FAILURE,
					],
				},
			});
		};
	},
	import: (subscriptionId, file, inviteMessage) => (dispatch) => {
		let body = new FormData();
		body.append('file', file);
		body.append('subscriptionId', subscriptionId);
		body.append('inviteMessage', inviteMessage);

		return dispatch({
			[CALL_API]: {
				endpoint: 'user/import',
				method: 'POST',
				body: body,
				types: [types.IMPORT_USERS_REQUEST, types.IMPORT_USERS_SUCCESS, types.IMPORT_USERS_FAILURE],
			},
		});
	},
	getSupportTickets: () => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/support-tickets',
					method: 'GET',
					types: [types.GET_SUPPORT_TICKETS_REQUEST, types.GET_SUPPORT_TICKETS_SUCCESS, types.GET_SUPPORT_TICKETS_FAILURE],
				},
			});
		};
	},
	saveUsersColumns: (request) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/save-columns',
					method: 'PUT',
					body: request,
					types: [types.SAVE_USER_COLUMNS_REQUEST, types.SAVE_USER_COLUMNS_SUCCESS, types.SAVE_USER_COLUMNS_FAILURE],
				},
			});
		};
	},
	getUserTaskInfo: (userId) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: `user/${userId}/task-info`,
					method: 'GET',
					types: [types.GET_USER_TASK_INFO_REQUEST, types.GET_USER_TASK_INFO_SUCCESS, types.GET_USER_TASK_INFO_FAILURE],
				},
			});
		};
	},
	getEligibleUsersForTaskReassignment: (userId, subscriptionId) => {
		return (dispatch) => {
			return dispatch({
				[CALL_API]: {
					endpoint: `user/${userId}/eligible-users-for-reassignment`,
					method: 'POST',
					body: { subscriptionId },
					types: [types.GET_ELIGIBLE_USERS_FOR_REASSIGNMENT_REQUEST, types.GET_ELIGIBLE_USERS_FOR_REASSIGNMENT_SUCCESS, types.GET_ELIGIBLE_USERS_FOR_REASSIGNMENT_FAILURE],
				},
			});
		};
	},
	reassignUserTasks: (fromUserId, toUserId) => {
		return (dispatch) => {
			const body = {
				fromUserId,
				toUserId,
			};
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/reassign-tasks',
					method: 'POST',
					body,
					types: [types.REASSIGN_USER_TASKS_REQUEST, types.REASSIGN_USER_TASKS_SUCCESS, types.REASSIGN_USER_TASKS_FAILURE],
				},
			});
		};
	},
	unassignUserTasks: (userId) => {
		return (dispatch) => {
			const body = {
				userId,
			};
			return dispatch({
				[CALL_API]: {
					endpoint: 'user/unassign-tasks',
					method: 'POST',
					body,
					types: [types.UNASSIGN_USER_TASKS_REQUEST, types.UNASSIGN_USER_TASKS_SUCCESS, types.UNASSIGN_USER_TASKS_FAILURE],
				},
			});
		};
	},
};
